import PropTypes from 'prop-types'
import React, { Component, Fragment } from 'react'
import injectSheet from 'react-jss'
import { Alert } from 'react-bootstrap'
import routes from 'src/routing/routes'
import { icon } from 'src/config/dataConf'
import { getMediaQuerySize } from 'src/utils'
import responsiveComponent from 'src/hoc/responsiveComponent'
import classnames from 'classnames'
import Spinner from '../../../../../components/Spinner'

const styles = () => {
  const mediaQuery = getMediaQuerySize()
  return {
    mapclass: {
      width: '100%',
      height: 320
    },
    mapclassAF: {
      width: '100%'
    },
    mapMobile: {
      opacity: 0,
      zIndex: -1
    },
    divMapAF: {
      backgroundColor: 'rgba(255,255,255, 0)',
      position: 'fixed',
      bottom: 0,
      right: 0,
      width: '66.66%',
      height: `calc(100vh - 268px)`,
      [mediaQuery]: {
        height: `calc(100vh - 204px)`
      }
    },
    alertZoom: {
      margin: 0,
      display: 'inline-block',
      position: 'absolute',
      top: 15,
      right: 15,
      zIndex: 401,
      width: 300
    },
    alertZoomAF: {
      margin: 0,
      display: 'inline-block',
      position: 'absolute',
      top: 0,
      right: 0,
      zIndex: 401
    },
    spinnerContainer: {
      zIndex: 401,
      position: 'relative',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      backgroundColor: 'rgba(144,144,144,0.3)'
    }
  }
}

let LeafletMap, TileLayer, Marker, Popup, MarkerClusterGroup
class MapProducers extends Component {
  constructor(props) {
    super(props)

    this.mapRef = React.createRef()

    this.state = {
      showProducer: false,
      heightWindow:
        typeof window !== 'undefined' ? window.innerHeight - 204 : 600 - 204,
      infoProducer: null,
      minZoomSearch: 8,
      activeZoom: null
    }

    if (typeof window !== 'undefined') {
      LeafletMap = require('react-leaflet').Map
      TileLayer = require('react-leaflet').TileLayer
      Marker = require('react-leaflet').Marker
      Popup = require('react-leaflet').Popup
      MarkerClusterGroup = require('react-leaflet-markercluster/src/react-leaflet-markercluster')
        .default
    }

    this.handleMarkerClickCache = {}
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      this.updateBounds()
      window.addEventListener('resize', this.updateWindowHeight)
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.updateWindowHeight)
    }
  }

  updateWindowHeight = () => {
    this.setState({
      heightWindow:
        typeof window !== 'undefined' ? window.innerHeight - 204 : 600 - 204
    })
  }

  updateBounds = () => {
    this.handleUpdateBounds(this.mapRef)
  }

  handleUpdateBounds = lMapRef => {
    const minZoom = this.state.minZoomSearch
    const activeZoom = lMapRef.current
      ? lMapRef.current.leafletElement.getZoom()
      : null

    if (lMapRef.current && activeZoom >= minZoom) {
      this.setState({
        showProducer: true,
        activeZoom
      })
      const bounds = lMapRef.current.leafletElement.getBounds()

      this.props.updateBounds([
        bounds.getNorthWest(),
        bounds.getNorthEast(),
        bounds.getSouthEast(),
        bounds.getSouthWest()
      ])
    } else {
      this.setState({
        showProducer: false,
        activeZoom
      })
    }
  }

  getDataProducer = arrayIndex => {
    this.setState({ infoProducer: this.props.producers[arrayIndex] })
  }

  handleMarkerClick = arrayIndex => {
    if (!(arrayIndex in this.handleMarkerClickCache)) {
      this.handleMarkerClickCache[arrayIndex] = () => {
        return this.getDataProducer(arrayIndex)
      }
    }

    return this.handleMarkerClickCache[arrayIndex]
  }

  render() {
    const {
      classes,
      coordinates,
      bounds,
      isMobile,
      producers,
      loading
    } = this.props
    const zoom = !isMobile ? 13 : 12

    return (
      <div
        className={classnames(
          classes.divMapAF,
          isMobile ? classes.mapMobile : ''
        )}
      >
        {typeof window !== 'undefined' ? (
          !bounds ? (
            <LeafletMap
              center={[coordinates[1], coordinates[0]]} // [lat, lng]
              zoom={zoom}
              className={classes.mapclassAF}
              style={{ height: this.state.heightWindow }}
              onViewportChanged={this.updateBounds}
              ref={this.mapRef}
            />
          ) : (
            <>
              {this.state.activeZoom &&
                this.state.activeZoom < this.state.minZoomSearch && (
                  <Alert bsStyle='warning' className={classes.alertZoomAF}>
                    <strong>
                      Zoomez pour rechercher les producteurs sur la carte
                    </strong>
                  </Alert>
                )}
              <LeafletMap
                bounds={bounds}
                className={classes.mapclassAF}
                style={{ height: this.state.heightWindow }}
                onViewportChanged={this.updateBounds}
                doubleClickZoom={false}
                ref={this.mapRef}
                minZoom={6}
              >
                <TileLayer
                  attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a>'
                  url={routes.urlTiles}
                />

                {!loading ? (
                  this.state.showProducer && (
                    <MarkerClusterGroup
                      chunkedLoading={true}
                      chunkInterval={25}
                      chunkDelay={25}
                    >
                      {producers.map((producer, i) => {
                        const selected =
                          this.state.infoProducer &&
                          this.state.infoProducer.id === producer.id

                        return (
                          <Marker
                            key={producer.id}
                            icon={icon}
                            position={[
                              producer.addressCoordinates[1],
                              producer.addressCoordinates[0]
                            ]} // [lat, lng]
                            onClick={this.handleMarkerClick(i)}
                          >
                            <Popup>
                              <span>
                                {selected ? (
                                  <Fragment>
                                    {this.state.infoProducer.companyName} <br />
                                    {`${this.state.infoProducer.addressCity} ${this.state.infoProducer.addressPostalCode}`}
                                    <br />
                                    <a
                                      href={routes.ficheProducteur.replace(
                                        ':id(\\d+)',
                                        this.state.infoProducer.id
                                      )}
                                    >
                                      Voir la fiche
                                    </a>
                                  </Fragment>
                                ) : (
                                  'chargement...'
                                )}
                              </span>
                            </Popup>
                          </Marker>
                        )
                      })}
                    </MarkerClusterGroup>
                  )
                ) : (
                  <div className={classes.spinnerContainer}>
                    <Spinner radius={60} />
                  </div>
                )}
              </LeafletMap>
            </>
          )
        ) : null}
      </div>
    )
  }
}

export default responsiveComponent(injectSheet(styles)(MapProducers))

MapProducers.propTypes = {
  bounds: PropTypes.array,
  coordinates: PropTypes.array,
  producers: PropTypes.array,
  updateBounds: PropTypes.func.isRequired
}
